import styled from 'styled-components'
import ReactSwitch from 'react-switch'

const Switch = styled(ReactSwitch)``

export default Switch
